import {
  VERIFICA_BOASVINDAS_REQUEST,
  VERIFICA_BOASVINDAS_SUCCESS,
  INSERE_BOASVINDAS_REQUEST,
  INSERE_BOASVINDAS_SUCCESS,
  RESET_BOASVINDAS,
} from './constants';

export function verificaTourBoasVindasRequest(matricula) {
  return {
    type: VERIFICA_BOASVINDAS_REQUEST,
    matricula,
  };
}

export function verificaTourBoasVindasSuccess(values) {
  return {
    type: VERIFICA_BOASVINDAS_SUCCESS,
    values,
  };
}

export function verificaRegistroBoasVindasError(values) {
  return {
    type: 'VERIFICA_BOASVINDAS_ERROR',
    values,
  };
}

export function insereRegistroBoasVindasRequest({ matricula, etapa }) {
  return {
    type: INSERE_BOASVINDAS_REQUEST,
    matricula,
    etapa,
  };
}

export function insereRegistroBoasVindasSuccess(values) {
  return {
    type: INSERE_BOASVINDAS_SUCCESS,
    values,
  };
}

export function insereRegistroBoasVindasError(values) {
  return {
    type: 'INSERE_BOASVINDAS_ERROR',
    values,
  };
}

export function resetBoasVindas() {
  return {
    type: RESET_BOASVINDAS,
  };
}
